export class CsError extends Error {
  // http status code to use.  Breaking abstraction layers a bit, but its simple.
  statusCode = 422

  // Error message that end users will see
  userErrorMessage = ''

  withUserErrorMessage(message: string) {
    this.userErrorMessage = message
    return this
  }

  withStatusCode(statusCode: number) {
    this.statusCode = statusCode
    return this
  }

  // Additional data to include in the error
  get userData() {
    return {}
  }
}
